import React from 'react'
import { Form } from 'semantic-ui-react'

export default class OnlineField extends React.PureComponent {
  render() {
    const { value, onChange } = this.props

    const options = [
      { key: 1, text: 'Available', value: 'available' },
      { key: 2, text: 'Busy', value: 'busy' },
      { key: 3, text: 'Pending', value: 'waiting_for_confirm' },
    ]

    return (
      <Form.Select
        required
        fluid
        label="Status"
        options={options}
        placeholder="Avialable/Pending/Busy/"
        onChange={(e, data) => onChange('status', data.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/fields/statusField.js